import React from 'react';
import { Wrench, RefreshCw, HardHat, ArrowRight } from 'lucide-react';
export function ProjectTypes() {
  return <section className="py-20 bg-white border-t border-slate-200" data-id="element-680">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-681">
        <div className="text-center mb-16 anim-on-scroll" data-id="element-682">
          <h2 className="kosins-heading text-4xl md:text-5xl text-neutral-900" data-id="element-683">
            What Kind of Commercial Glass Project Do You Need?
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-10" data-id="element-684">
          {/* Card 1 */}
          <div className="bg-slate-50 rounded-2xl p-8 border border-slate-200 flex flex-col h-full relative overflow-hidden scroll-fade-up" style={{
          animationDelay: '0s'
        }} data-id="element-685">
            <div className="absolute top-0 right-0 w-24 h-24 bg-primary-100 rounded-bl-full -mr-4 -mt-4 opacity-50" data-id="element-686"></div>
            <Wrench className="w-10 h-10 text-primary-600 mb-6 relative z-10" data-id="element-687" />
            <h3 className="kosins-heading text-3xl text-neutral-900 mb-4" data-id="element-688">
              Storefront or Door Repair
            </h3>
            <div className="mb-4 text-sm font-semibold text-slate-500 uppercase tracking-wider" data-id="element-689">
              Best for:
            </div>
            <ul className="space-y-3 mb-8 flex-grow" data-id="element-690">
              {['Broken storefront glass', 'Damaged commercial door glass', 'Cracked business window glass', 'Failed insulated glass units', 'Existing building service or maintenance'].map((item, i) => <li key={i} className="flex items-start gap-2 text-slate-700" data-id="element-691">
                  <div className="w-1.5 h-1.5 rounded-full bg-primary-500 mt-2 shrink-0" data-id="element-692"></div>
                  <span data-id="element-693">{item}</span>
                </li>)}
            </ul>
            <a href="#quote-form" className="w-full py-3 px-4 bg-white border-2 border-primary-600 text-primary-700 font-semibold rounded-lg hover:bg-primary-50 transition-colors flex items-center justify-center gap-2 group" data-id="element-694">
              Repair My Storefront Glass
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-695" />
            </a>
          </div>

          {/* Card 2 */}
          <div className="bg-navy-900 rounded-2xl p-8 border border-navy-800 flex flex-col h-full relative overflow-hidden shadow-xl transform md:-translate-y-4 scroll-fade-up" style={{
          animationDelay: '0.1s'
        }} data-id="element-696">
            <div className="absolute top-0 right-0 w-24 h-24 bg-primary-600 rounded-bl-full -mr-4 -mt-4 opacity-20" data-id="element-697"></div>
            <RefreshCw className="w-10 h-10 text-primary-400 mb-6 relative z-10" data-id="element-698" />
            <h3 className="kosins-heading text-3xl text-white mb-4" data-id="element-699">
              Renovation or Replacement
            </h3>
            <div className="mb-4 text-sm font-semibold text-slate-400 uppercase tracking-wider" data-id="element-700">
              Best for:
            </div>
            <ul className="space-y-3 mb-8 flex-grow" data-id="element-701">
              {['Business window replacement', 'Storefront upgrades', 'Office remodels', 'Glass wall installation', 'Lobby or entryway improvements'].map((item, i) => <li key={i} className="flex items-start gap-2 text-slate-300" data-id="element-702">
                  <div className="w-1.5 h-1.5 rounded-full bg-primary-400 mt-2 shrink-0" data-id="element-703"></div>
                  <span data-id="element-704">{item}</span>
                </li>)}
            </ul>
            <a href="#quote-form" className="w-full py-3 px-4 bg-primary-600 text-white font-semibold rounded-lg hover:bg-primary-500 transition-colors flex items-center justify-center gap-2 group" data-id="element-705">
              Plan a Commercial Glass Upgrade
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-706" />
            </a>
          </div>

          {/* Card 3 */}
          <div className="bg-slate-50 rounded-2xl p-8 border border-slate-200 flex flex-col h-full relative overflow-hidden scroll-fade-up" style={{
          animationDelay: '0.2s'
        }} data-id="element-707">
            <div className="absolute top-0 right-0 w-24 h-24 bg-primary-100 rounded-bl-full -mr-4 -mt-4 opacity-50" data-id="element-708"></div>
            <HardHat className="w-10 h-10 text-primary-600 mb-6 relative z-10" data-id="element-709" />
            <h3 className="kosins-heading text-3xl text-neutral-900 mb-4" data-id="element-710">
              Contract Glazing
            </h3>
            <div className="mb-4 text-sm font-semibold text-slate-500 uppercase tracking-wider" data-id="element-711">
              Best for:
            </div>
            <ul className="space-y-3 mb-8 flex-grow" data-id="element-712">
              {['New construction', 'Tenant build-outs', 'Exterior glazing systems', 'Curtain walls and storefront systems', 'Projects needing bid coordination, fabrication and installation'].map((item, i) => <li key={i} className="flex items-start gap-2 text-slate-700" data-id="element-713">
                  <div className="w-1.5 h-1.5 rounded-full bg-primary-500 mt-2 shrink-0" data-id="element-714"></div>
                  <span data-id="element-715">{item}</span>
                </li>)}
            </ul>
            <a href="#quote-form" className="w-full py-3 px-4 bg-white border-2 border-primary-600 text-primary-700 font-semibold rounded-lg hover:bg-primary-50 transition-colors flex items-center justify-center gap-2 group" data-id="element-716">
              Request a Contract Glazing Bid
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-717" />
            </a>
          </div>
        </div>

        <div className="text-center max-w-2xl mx-auto anim-on-scroll" data-id="element-718">
          <p className="text-sm text-slate-500 bg-slate-100 py-3 px-6 rounded-full inline-block" data-id="element-719">
            Kosin’s Glass can review your scope, photos, measurements, drawings,
            timeline and location to recommend the right next step.
          </p>
        </div>
      </div>
    </section>;
}